import React from "react";
import styles from "./styles.module.scss";
import { cn } from "@/utils";

type SLoadingSpinnerProps = {
  wrapperClassName?: string;
};

const SLoadingSpinner = ({ wrapperClassName }: SLoadingSpinnerProps) => {
  return (
    <div className={cn(wrapperClassName)}>
      <div className={styles.loading} />
    </div>
  );
};

export default SLoadingSpinner;
